export default {
    SET_RESPONSE(state, val) {
        state.isResponse.code = val;
    },
    SET_MODAL_USAGE(state, val) {
        state.modalUsage = val;
    }
}